module.exports = __webpack_public_path__ + "img/43800.aea2ab34.jpg";